"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var faCircle_1 = require("@fortawesome/pro-light-svg-icons/faCircle");
var end2end_1 = require("@hudled/end2end");
var material_1 = require("@mui/material");
var final_form_1 = require("final-form");
var react_final_form_1 = require("react-final-form");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var LineButton_1 = __importDefault(require("atomicComponents/atoms/Buttons/LineButton"));
var JustifiedRow_1 = __importDefault(require("atomicComponents/atoms/Div/JustifiedRow"));
var NewModal_1 = __importDefault(require("atomicComponents/organisms/Modal/NewModal/NewModal"));
var hooks_1 = require("containers/ConfirmationModal/hooks");
var FormAutocomplete_1 = __importDefault(require("containersRechargly/Recharges/Setup/Dropdowns/FormAutocomplete"));
var InputInvoiceFields_1 = __importDefault(require("containersRechargly/Recharges/Setup/ModalComponents/InputInvoiceFields"));
var UploadCSV_1 = __importDefault(require("containersRechargly/Recharges/Setup/ModalComponents/UploadCSV"));
var utils_1 = require("containersRechargly/Recharges/Setup/ModalComponents/utils");
var Text_1 = __importDefault(require("shared/components/Text"));
var backend_1 = require("utils/backend");
var options_1 = require("utils/selectors/options");
var single_1 = require("utils/selectors/single");
var UploadCustomCsvModal = function (_a) {
    var onClose = _a.onClose;
    // const [invoiceVoided, setInvoiceVoided] = React.useState(false);
    var rechCompany = (0, react_redux_1.useSelector)(single_1.selectMyRechargerCompany);
    var _b = __read((0, backend_1.useCall)('dataextract-uploadrechargedatacall', { companyId: rechCompany === null || rechCompany === void 0 ? void 0 : rechCompany.id }), 1), uploadRecharges = _b[0];
    var vendorOptions = (0, react_redux_1.useSelector)(options_1.selectRechargedVendorsOptions);
    var history = (0, react_router_dom_1.useHistory)();
    var confirm = (0, hooks_1.useConfirm)();
    var onSubmit = function (_a) { return __awaiter(void 0, void 0, void 0, function () {
        var _b, csvFileError, csvString, invNumber, result;
        var _c, _d;
        var _e;
        var csvFile = _a.csvFile, values = __rest(_a, ["csvFile"]);
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0: return [4 /*yield*/, (0, utils_1.validateCsvFile)('custom')(csvFile)];
                case 1:
                    _b = _f.sent(), csvFileError = _b.error, csvString = _b.csvString;
                    if (csvFileError) {
                        return [2 /*return*/, (_c = {}, _c[final_form_1.FORM_ERROR] = 'Wrong CSV', _c.csvFile = csvFileError, _c)];
                    }
                    invNumber = values === null || values === void 0 ? void 0 : values.number;
                    return [4 /*yield*/, uploadRecharges((0, backend_1.parseParams)({
                            dataSource: __assign(__assign({}, values), { csvString: csvString, date: (0, end2end_1.getISODate)((_e = values.date) !== null && _e !== void 0 ? _e : new Date()), isCustomCsv: true }),
                        }))()];
                case 2:
                    result = _f.sent();
                    if (!!(result === null || result === void 0 ? void 0 : result.data.error)) return [3 /*break*/, 4];
                    return [4 /*yield*/, confirm('Charges successfully imported', '', 'green', 'OK!', true)];
                case 3:
                    _f.sent();
                    history.push("/recharges/charges/all".concat(invNumber ? "?search=".concat(invNumber) : ''));
                    _f.label = 4;
                case 4: return [2 /*return*/, (result === null || result === void 0 ? void 0 : result.data.error) && (_d = {}, _d[final_form_1.FORM_ERROR] = result.data.error, _d)];
            }
        });
    }); };
    // if (invoiceVoided) {
    //   return <SuccessContent onClose={onClose} rechInvoice={rechInvoice} />;
    // }
    return ((0, jsx_runtime_1.jsx)(react_final_form_1.Form, __assign({ onSubmit: onSubmit, initialValues: { currency: rechCompany === null || rechCompany === void 0 ? void 0 : rechCompany.rechargesCurrency } }, { children: function (_a) {
            var handleSubmit = _a.handleSubmit, submitting = _a.submitting;
            return ((0, jsx_runtime_1.jsxs)(NewModal_1.default, __assign({ open: true, textAlign: "left", icon: faCircle_1.faCircle, iconColor: "azzurro.main", title: "Custom CSV Import", subTitle: "Use this feature to import custom charges to multiple organisations.", footerContent: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(LineButton_1.default, __assign({ color: "neutral", size: "large", onClick: function () { return onClose === null || onClose === void 0 ? void 0 : onClose(); } }, { children: "Close" })), (0, jsx_runtime_1.jsx)(LineButton_1.default, __assign({ color: "azzurro", size: "large", onClick: handleSubmit, isSending: submitting }, { children: "Submit" }))] })), maxWidth: "sm", onClose: onClose }, { children: [(0, jsx_runtime_1.jsx)(UploadCSV_1.default, { vendor: "custom" }), (0, jsx_runtime_1.jsx)(InputInvoiceFields_1.default, __assign({ vendor: "custom" }, { children: (0, jsx_runtime_1.jsxs)(JustifiedRow_1.default, { children: [(0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1 }, { children: "Vendor" })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ width: 240 }, { children: (0, jsx_runtime_1.jsx)(react_final_form_1.Field, { component: FormAutocomplete_1.default, name: "vendor", options: vendorOptions, label: "Select vendor", placeholder: "Select vendor", size: "small" }) }))] }) }))] })));
        } })));
};
exports.default = UploadCustomCsvModal;
